import React from "react";

const SLOGANS = [
  "Awareness Creates Change",
  "Knowledge is Power",
  "Be Aware. Be Responsible.",
  "Real Change Starts With You",
  "Raise Your Voice",
  "Respect Every Voice",
  "Your Action Matters",
  "Youth Can Lead India",
  "Together We Build Tomorrow",
  "India Needs Informed Citizens",
  "Learn • Lead • Serve",
];

export const SloganStrip = () => (
  <section aria-label="CAF slogans" className="relative overflow-hidden bg-black text-white border-y border-white/10">
    <div className="absolute inset-x-0 top-0 h-0.5 tricolour-strip-h" aria-hidden="true" />
    <div className="absolute inset-x-0 bottom-0 h-0.5 tricolour-strip-h" aria-hidden="true" />
    <div className="py-3 flex whitespace-nowrap marquee-track">
      {[...SLOGANS, ...SLOGANS].map((s, i) => (
        <div key={i} className="flex items-center gap-3 px-6 shrink-0">
          <span className="h-1.5 w-1.5 rounded-full bg-[hsl(var(--orange))]" />
          <span className="text-xs sm:text-sm font-semibold uppercase tracking-[0.22em] text-white/90">{s}</span>
        </div>
      ))}
    </div>
  </section>
);
